import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DxButtonModule, DxTextBoxModule, DxPopupModule, DxScrollViewModule, DxToastModule } from 'devextreme-angular';
import { CtlTmsCikisYerAramaComponent } from './ctl-tms-cikis-yer-arama/ctl-tms-cikis-yer-arama.component';
import { TmsCikisYerService} from './ctl-tms-cikis-yer.service';
import { CommonModule } from '@angular/common';
import { CtlSablonComponent, OrtakService, UtilsService } from '@dabnet-kamu/libs/ui';
import { LabelMode } from 'devextreme/common';

@Component({
  selector: 'dk-ctl-tms-cikis-yer',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTmsCikisYerAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
    DxToastModule
  ],
  providers: [TmsCikisYerService],
  templateUrl: './ctl-tms-cikis-yer.component.html',
  styleUrls: ['./ctl-tms-cikis-yer.component.scss'],
})
export class CtlTmsCikisYerComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode:LabelMode = null;
  public crudPopupVisible = false;
  public title!: string;
public isFirst = true;
  public control!: any;
  controlName = "TmsCikisYer";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public data: any;
  @Input() code: any;
  @Input() belediyeCode: any;
  @Input() validationRulesMap:any[] = [];
  @Input() validationV2= false;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: TmsCikisYerService, private utilsService: UtilsService, private ortakService: OrtakService) {}

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    if (!this.belediyeCode) {
      this.toastMessage = "Belediye Seçili Değil."
      this.showAction = false
    }
    this.setParams();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['belediyeCode']) {
      if(this.belediyeCode == null) this.showAction = false
      else{
        this.showAction = true
        this.setParams()
      }
    }
    if (changes['isReadOnly'] || changes['isBindCheck']) {
    this.setParams();
      }
  }
  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }


  setParams(){
    this.service.belediyeCode = this.belediyeCode;
    this.service.isReadOnly = this.isReadOnly;
    this.service.isBindCheck = this.isBindCheck;
  }

  searchClick() {
    if(this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if(this.showAction){
      if (e === '' || e === null) this.clear();
      else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
    }
    else this.toastVisible = true
  }

  getData(code: any, isSetData?: boolean) {

    this.data = this.service.getData(Number(code),this.control, this.belediyeCode,this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].Ad;
        this.code = result[0].Kod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }

    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.Kod;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}

